import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppPath} from "@pg-mono/rp-routes";

import {useCurrentRoute} from "../../../hooks/use_current_route";
import {useAppSelector} from "../../../store/hooks";
import {useSemanticSearchSubmit} from "../../hooks/use_semantic_search_submit";
import {selectSemanticSearchHasConversation} from "../../state/select_semantic_search_has_conversation";
import {hitAiAssistantBadge} from "../../tracking/semantic_search_gtm_events";
import {SemanticSearchFormValues} from "../../types/SemanticSearchFormValues";
import {SemanticSearchQueryForm} from "./SemanticSearchQueryForm";
import {SemanticSearchQuickQuestions} from "./SemanticSearchQuickQuestions";

interface IProps {
    hasStickySidebar: boolean;
    quickQuestionsLayout?: "column" | "inline";
    onSubmit?: () => void;
}

export function SemanticSearchQuery(props: IProps) {
    const {hasStickySidebar, quickQuestionsLayout = "column", onSubmit} = props;

    const {pathname} = useCurrentRoute();
    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);
    const {clearHistory, isLoading, semanticSearchHistory, submitSemanticSearch} = useSemanticSearchSubmit();

    // Display clear history button only on /szukaj page
    const isSearchPage = pathname.includes(rpAppPath.semanticSearch.base);

    const handleSubmit = (data: SemanticSearchFormValues) => {
        void submitSemanticSearch(data);
        onSubmit?.();
    };

    const handleQuickQuestionSelect = (userQuery: string) => {
        hitAiAssistantBadge(userQuery);
        void submitSemanticSearch({userQuery});
        onSubmit?.();
    };

    const handleClearHistory = () => {
        clearHistory();
    };

    // Pin the panel to the bottom only while a conversation is scrolling; in the empty state it flows
    // in the centered column below the header so it doesn't overlap it.
    return (
        <div
            className={cx(
                semanticSearchQueryWrapper,
                hasStickySidebar && semanticSearchQueryWrapperStyling,
                hasConversation ? semanticSearchQueryPositionSticky : semanticSearchQueryPositionRelative
            )}
        >
            <div className={cx(semanticSearchQueryContent, hasStickySidebar && semanticSearchQueryContentSticky)}>
                <div className={cx(semanticSearchFormWrap, hasStickySidebar && semanticSearchFormWrapSticky)}>
                    {semanticSearchHistory && semanticSearchHistory.length > 0 && isSearchPage && (
                        <div className={clearHistoryLinkWrapper}>
                            <button type="button" onClick={handleClearHistory} className={clearHistoryLink}>
                                <Text variant="info_txt_1" className={clearHistoryLinkText}>
                                    Zacznij od nowa
                                </Text>
                            </button>
                        </div>
                    )}

                    {!hasConversation && (
                        <SemanticSearchQuickQuestions disabled={isLoading} layout={quickQuestionsLayout} onSelectQuestion={handleQuickQuestionSelect} />
                    )}

                    <SemanticSearchQueryForm
                        handleSubmit={handleSubmit}
                        disabled={isLoading}
                        hasConversation={hasConversation}
                        hasStickySidebar={hasStickySidebar}
                    />
                </div>
            </div>
        </div>
    );
}

// Styles
const semanticSearchQueryWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    p: 1.5,
    pb: 0,
    transition: "all 0.3s ease-in-out",
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 10
});

const semanticSearchQueryPositionSticky = css({
    position: "sticky",
    boxShadow: "var(--shadows-4)"
});

const semanticSearchQueryPositionRelative = css({
    position: "relative"
});

const semanticSearchQueryWrapperStyling = css({
    p: 0,
    background: "var(--colors-white)"
});

const semanticSearchQueryContent = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    width: "100%",
    maxWidth: "744px"
});

const semanticSearchQueryContentSticky = css({
    pb: 2,
    px: 1.5
});

const semanticSearchFormWrap = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    transition: "all 0.3s ease-in-out"
});

const semanticSearchFormWrapSticky = css({
    p: 0,
    background: "var(--colors-white)",
    borderRadius: 2
});

const clearHistoryLinkWrapper = css({
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: 1
});

const clearHistoryLink = css({
    padding: 0,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer"
});

const clearHistoryLinkText = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",

    _hover: {
        color: "var(--colors-gray-900)"
    }
});
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {rpAppPath} from "@pg-mono/rp-routes";

import {useCurrentRoute} from "../../../hooks/use_current_route";
import {useAppSelector} from "../../../store/hooks";
import {useSemanticSearchSubmit} from "../../hooks/use_semantic_search_submit";
import {selectSemanticSearchHasConversation} from "../../state/select_semantic_search_has_conversation";
import {hitAiAssistantBadge} from "../../tracking/semantic_search_gtm_events";
import {SemanticSearchFormValues} from "../../types/SemanticSearchFormValues";
import {SemanticSearchQueryForm} from "./SemanticSearchQueryForm";
import {SemanticSearchQuickQuestions} from "./SemanticSearchQuickQuestions";

interface IProps {
    hasStickySidebar: boolean;
    quickQuestionsLayout?: "column" | "inline";
    onSubmit?: () => void;
}

export function SemanticSearchQuery(props: IProps) {
    const {hasStickySidebar, quickQuestionsLayout = "column", onSubmit} = props;

    const {pathname} = useCurrentRoute();
    const hasConversation = useAppSelector(selectSemanticSearchHasConversation);
    const {clearHistory, isLoading, semanticSearchHistory, submitSemanticSearch} = useSemanticSearchSubmit();

    // Display clear history button only on /szukaj page
    const isSearchPage = pathname.includes(rpAppPath.semanticSearch.base);

    const handleSubmit = (data: SemanticSearchFormValues) => {
        void submitSemanticSearch(data);
        onSubmit?.();
    };

    const handleQuickQuestionSelect = (userQuery: string) => {
        hitAiAssistantBadge(userQuery);
        void submitSemanticSearch({userQuery});
        onSubmit?.();
    };

    const handleClearHistory = () => {
        clearHistory();
    };

    // Pin the panel to the bottom only while a conversation is scrolling; in the empty state it flows
    // in the centered column below the header so it doesn't overlap it.
    return (
        <div
            className={cx(
                semanticSearchQueryWrapper,
                hasStickySidebar && semanticSearchQueryWrapperStyling,
                hasConversation ? semanticSearchQueryPositionSticky : semanticSearchQueryPositionRelative
            )}
        >
            <div className={cx(semanticSearchQueryContent, hasStickySidebar && semanticSearchQueryContentSticky)}>
                <div className={cx(semanticSearchFormWrap, hasStickySidebar && semanticSearchFormWrapSticky)}>
                    {semanticSearchHistory && semanticSearchHistory.length > 0 && isSearchPage && (
                        <div className={clearHistoryLinkWrapper}>
                            <button type="button" onClick={handleClearHistory} className={clearHistoryLink}>
                                <Text variant="info_txt_1" className={clearHistoryLinkText}>
                                    Zacznij od nowa
                                </Text>
                            </button>
                        </div>
                    )}

                    {!hasConversation && (
                        <SemanticSearchQuickQuestions disabled={isLoading} layout={quickQuestionsLayout} onSelectQuestion={handleQuickQuestionSelect} />
                    )}

                    <SemanticSearchQueryForm
                        handleSubmit={handleSubmit}
                        disabled={isLoading}
                        hasConversation={hasConversation}
                        hasStickySidebar={hasStickySidebar}
                    />
                </div>
            </div>
        </div>
    );
}

// Styles
const semanticSearchQueryWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    p: 1.5,
    pb: 0,
    transition: "all 0.3s ease-in-out",
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 10
});

const semanticSearchQueryPositionSticky = css({
    position: "sticky",
    boxShadow: "var(--shadows-4)"
});

const semanticSearchQueryPositionRelative = css({
    position: "relative"
});

const semanticSearchQueryWrapperStyling = css({
    p: 0,
    background: "var(--colors-white)"
});

const semanticSearchQueryContent = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    width: "100%",
    maxWidth: "744px"
});

const semanticSearchQueryContentSticky = css({
    pb: 2,
    px: 1.5
});

const semanticSearchFormWrap = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    transition: "all 0.3s ease-in-out"
});

const semanticSearchFormWrapSticky = css({
    p: 0,
    background: "var(--colors-white)",
    borderRadius: 2
});

const clearHistoryLinkWrapper = css({
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: 1
});

const clearHistoryLink = css({
    padding: 0,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer"
});

const clearHistoryLinkText = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)",

    _hover: {
        color: "var(--colors-gray-900)"
    }
});
